import React from "react";
import { PlusIcon } from "@heroicons/react/solid";

import IconButton from "../components/ui/IconButton";
import useModal from "../hooks/useModal";
import { GoalsFormModal } from "../features/goals";

// sticky header with button to open goal modal
const Header: React.FC = () => {
  // custom hook to open and close modal
  const { isOpen, handleModaltoggle } = useModal();

  return (
    <>
      {isOpen && <GoalsFormModal onClose={handleModaltoggle} />}
      <header className="sticky top-0 z-50 bg-transparent">
        <div className="container py-2 flex items-center justify-end">
          <IconButton
            Icon={PlusIcon}
            label="new goal"
            className="primary-btn text-xl"
            onClick={handleModaltoggle}
          />
        </div>
      </header>
    </>
  );
};

export default Header;
